import React, { useEffect, useState } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { ewbApi } from '@/services/ewayBillApi';

const same = (a, b) => (a || '').trim().toLowerCase() === (b || '').trim().toLowerCase();

/** Part B transporter: picked from the Transport Master (or none) → its Transporter ID fills in; a typed ID is saved to the master on create. */
export const TransporterPick = ({ v, onChange, err }) => {
  const [list, setList] = useState(null);
  const [dropped, setDropped] = useState('');
  useEffect(() => { ewbApi.transporters().then(setList).catch(() => setList([])); }, []);
  const sel = v.transporter_name ? (list || []).find((t) => same(t.name, v.transporter_name)) : null;
  useEffect(() => {
    if (!list) return;
    const mid = (sel?.ewb_transporter_id || '').toUpperCase();
    if (sel && (sel.transport_id !== v.transport_id || sel.name !== v.transporter_name || (mid && mid !== v.transporter_id))) {
      onChange({ ...v, transport_id: sel.transport_id, transporter_name: sel.name, transporter_id: mid || v.transporter_id });
    } else if (!sel && (v.transporter_name || v.transport_id)) {
      if (v.transporter_name) setDropped(v.transporter_name);
      onChange({ ...v, transport_id: null, transporter_name: '', transporter_id: '' });
    }
  }, [list, sel, v, onChange]);
  const pick = (id) => {
    const t = (list || []).find((x) => x.transport_id === id);
    setDropped('');
    onChange({ ...v, transport_id: t?.transport_id || null, transporter_name: t?.name || '', transporter_id: (t?.ewb_transporter_id || '').toUpperCase() });
  };
  const masterId = (sel?.ewb_transporter_id || '').trim();
  const note = !sel ? 'Pick a transporter to fill its ID' : masterId ? 'From the Transport Master' : 'Not in the Transport Master yet — saved there when you create this e-way bill';
  return (
    <>
      <div className="space-y-1"><Label className="text-xs">Transporter name</Label>
        <select value={sel?.transport_id || ''} onChange={(e) => pick(e.target.value)} disabled={!list} title={sel?.name || ''}
          className="h-10 w-full rounded-md border border-gray-300 bg-white px-3 text-sm disabled:opacity-60" data-testid="ewb-transporter-select">
          <option value="">{list ? '— None —' : 'Loading transporters…'}</option>
          {(list || []).map((t) => <option key={t.transport_id} value={t.transport_id}>{t.name}</option>)}
        </select>
        {list && !list.length && <p className="text-xs text-amber-700" data-testid="ewb-transporter-empty">No active transporters — add them in Transport Master</p>}
        {dropped && !sel && <p className="text-xs text-amber-700" data-testid="ewb-transporter-dropped">'{dropped}' (from the pick slip / document) isn't in the Transport Master — add it there or pick one here</p>}</div>
      <div className="space-y-1"><Label className="text-xs">Transporter ID (GSTIN / TRANSIN)</Label>
        <Input value={v.transporter_id} onChange={(e) => onChange({ ...v, transporter_id: e.target.value.toUpperCase() })} maxLength={15}
          readOnly={!!masterId} disabled={!sel} placeholder={sel ? '15-character GSTIN / TRANSIN' : ''}
          className={`font-mono uppercase ${masterId ? 'bg-gray-50' : ''}`} data-testid="ewb-transporter-id" />
        {err || <p className={`text-xs ${sel && !masterId ? 'text-amber-700' : 'text-gray-500'}`} data-testid="ewb-transporter-id-note">{note}</p>}</div>
    </>
  );
};

export default TransporterPick;
